import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { DropContent, DropItem, DropList, MenuButton, MenuDropdown, MenuRefresh, MenuWrap } from './SubNav.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';

import Dash_Icon from '@assets/svg/subnav_dash.svg'
import Note_Icon from '@assets/svg/subnav_note.svg'
import Registration_Icon from '@assets/svg/subnav_registration.svg'
import Statistik_Icon from '@assets/svg/subnav_statistik.svg'
import Course_Icon from '@assets/svg/subnav_course.svg'
import Free_Icon from '@assets/svg/subnav_free.svg'
import Refresh_Icon from '@assets/svg/refresh.svg'
import Sick_Icon from '@assets/svg/sick.svg'
import Chevron_Icon from '@assets/svg/chevron_fat_down.svg'

import SubNavSearch from '../SubNavSearch';
import Tooltip from '@components/Tooltips/Tooltip';
import toTitleCase from '@utils/textTools';

interface IProps {
  refresh: () => void,
  loading: boolean,
  secretary?:boolean
}

export const SubNav = forwardRef((props: IProps, ref) => {
  const { client, callNameSetting, setSchoolLeaderView, schoolLeaderView, selectedSchoolViewSearch, setSelectedSchoolViewSearch, setSchoolViewDateRange, schoolViewDateRange, setPage, systemSettings, settings, kohortsAvailable } = useStore();
  const [showDropdown, setShowDropDown] = useState(false)
  const [lastUpdate, setLastUpdate] = useState(moment())
  const i18n = useI18n();
  const searchRef = useRef(null);
  let s = systemSettings?.find(s => s.APP_Setting_ID === 74)  
  let s2 = systemSettings?.find(s => s.APP_Setting_ID === 77) 
  let s3 = systemSettings.find(s => s.APP_Setting_ID === 9)?.value.toLowerCase() === "true"
  let useMissingTeacherRegistrations = systemSettings?.find(s => s.APP_Setting_ID === 105)
  
  useImperativeHandle(ref, () => ({
          handleClickRef(username, id, displayname, type, course?) {
              searchRef?.current?.handleClickRef(username, id, displayname, type, course)
          },
      }));

  const handleClick = (id) => {
    if (id !== 7) {
      setPage(1)
      setSelectedSchoolViewSearch(null)
    }
    setSchoolLeaderView(id === 7 && id === schoolLeaderView ? null : id)
    setShowDropDown(false)   
  }

  const getDateText = () => {
    if(schoolLeaderView === 0 && schoolViewDateRange === 1)return  i18n.t("dash-select1")
    else if(schoolLeaderView === 0 && schoolViewDateRange === 2)return i18n.t("dash-select2")
    else if(schoolLeaderView === 0 && schoolViewDateRange === 3)return i18n.t("dash-select3")
    else if(schoolLeaderView === 0 && schoolViewDateRange === 4)return i18n.t("dash-select4")
    else if(schoolLeaderView === 0 && schoolViewDateRange === 5)return i18n.t("dash-select5")
    else return i18n.t("sub-nav1")
  }

  const handleUpdateClick = async () => {    
    await props.refresh()
    setLastUpdate(moment())
  }

  return (<>
    <MenuWrap>
        <MenuButton active={schoolLeaderView === 0 && !selectedSchoolViewSearch} onClick={() => handleClick(0)}>
          <Dash_Icon />
          <span>{i18n.t("sub-nav1")}</span>
        </MenuButton>

      <MenuButton active={schoolLeaderView === 1 && !selectedSchoolViewSearch} onClick={() => handleClick(1)}>
        <Registration_Icon />
        {toTitleCase(i18n.t(callNameSetting + "-s"))}
      </MenuButton>
      <MenuButton active={schoolLeaderView === 2 && !selectedSchoolViewSearch} onClick={() => handleClick(2)}>
        <Course_Icon />
        {i18n.t("class")}
      </MenuButton>
      {kohortsAvailable === true?<MenuButton active={schoolLeaderView === 8 && !selectedSchoolViewSearch} onClick={() => handleClick(8)}>
        <Course_Icon />
        {i18n.t("subnav-kohort")}
      </MenuButton>:null}
      <MenuButton active={schoolLeaderView === 3 && !selectedSchoolViewSearch} onClick={() => handleClick(3)}>
        <Registration_Icon />
        {i18n.t("sub-nav3")}
      </MenuButton>
      {useMissingTeacherRegistrations?.value == "true" ?<MenuButton active={schoolLeaderView === 10 && !selectedSchoolViewSearch} onClick={() => handleClick(10)}>
        <Registration_Icon />
        {i18n.t("sub-nav10")}
      </MenuButton>:null}
      {s3 && <MenuButton active={schoolLeaderView === 4 && !selectedSchoolViewSearch} onClick={() => handleClick(4)}>
        <Note_Icon />
        {i18n.t("menu-note")}
      </MenuButton>}
      {((props.secretary && s2.value.toLowerCase() === "true") || (!props.secretary && s.value.toLowerCase() === "true"))?<MenuButton active={schoolLeaderView === 5 && !selectedSchoolViewSearch} onClick={() => handleClick(5)}>
        <Free_Icon />
        {i18n.t("sub-nav5")}
      </MenuButton>:null}
      {/*<MenuButton active={schoolLeaderView === 6 && !selectedSchoolViewSearch} onClick={() => handleClick(6)}>
        <Statistik_Icon />
        Statistik{i18n.t("class")}
      </MenuButton>*/}
      {selectedSchoolViewSearch && selectedSchoolViewSearch.type === "STUDENT" ? <MenuButton active={schoolLeaderView === 7} onClick={() => handleClick(7)}>
        <Sick_Icon />
        {i18n.t("sub-nav7")}
      </MenuButton> : null}

      <MenuRefresh loading={props.loading || undefined} onClick={props.loading ? null : handleUpdateClick}>
        <Tooltip content={i18n.t("data-update1") + " " + moment(lastUpdate).format('HH:mm:ss') + ". " + i18n.t("data-update2")}>
          <Refresh_Icon />
        </Tooltip>
      </MenuRefresh>
  
  
      <SubNavSearch ref={searchRef} />
    </MenuWrap>
  </>);
});

export default SubNav;
